import React, { useCallback } from 'react';
import '../Usuarios/EditarUsuario.css';
import { useNavigate } from "react-router-dom";
import { ReactComponent as Volver } from '../assets/icon/volver.svg';

function EditarUsuario() {
    const navigate = useNavigate();

    const handleNavigateBack = useCallback(() => {
        navigate("/dashboard/usuarios");
    }, [navigate]);

    return (
        <div className='bodyEditarUsuarios'>

            {/* TÍTULO */}
            <div className='tituloEditarUsuarios'><p>-Usuario</p></div>

            <div className='cuerpoBotonVolverUsuario'>
<button
                    className='botonesEditarUsuario'
                    onClick={handleNavigateBack}
                >
                    <div className="svgBotones"><Volver className="logo-svgBotones" /></div>
                    Volver
                </button>
            </div>

            <div className='cuerpoEditarUsuario'>
                {/* INPUT NOMBRE */}
                <div className="input-groupEditarUsuario">
                    <div className='text-inputEditarUsuario'>
                        <label htmlFor="TituloEditarUsuario">Nombre</label>
                    </div>
                    <input
                        className="inputEditarUsuario"
                        type="Text"
                        id="text"
                        placeholder="Omar Alberto"
                    />
                </div>
                {/* INPUT apellido */}
                <div className="input-groupEditarUsuario">
                    <div className='text-inputEditarUsuario'>
                        <label htmlFor="TituloEditarUsuario">Apellido</label>
                    </div>
                    <input
                        className="inputEditarUsuario"
                        type="Text"
                        id="text"
                        placeholder="Martinez Castro"
                    />
                </div>
                {/* correo electronico */}
                <div className="input-groupEditarUsuario">
                    <div className='text-inputEditarUsuario'>
                        <label htmlFor="TituloEditarUsuario">Correo electrónico</label>
                    </div>
                    <input
                        className="inputEditarUsuario"
                        type="Text"
                        id="text"
                        placeholder="panel6b@6bplus.com.mx"
                    />
                </div>
                {/* celular */}
                <div className="input-groupEditarUsuario">
                    <div className='text-inputEditarUsuario'>
                        <label htmlFor="TituloEditarUsuario">Celular</label>
                    </div>
                    <input
                        className="inputEditarUsuario"
                        type="Text"
                        id="text"
                        placeholder="9343489022"
                    />
                </div>
                {/* estado */}
                <div className="input-groupEditarUsuario">
                    <div className='text-inputEditarUsuario'>
                        <label htmlFor="TituloEditarUsuario">Estado</label>
                    </div>
                    <input
                        className="inputEditarUsuario"
                        type="Text"
                        id="text"
                        placeholder="Ciudad de Mexico"
                    />
                </div>
                {/* numero tarjeta */}
                <div className="input-groupEditarUsuario">
                    <div className='text-inputEditarUsuario'>
                        <label htmlFor="TituloEditarUsuario">Número Tarjeta</label>
                    </div>
                    <input
                        className="inputEditarUsuario"
                        type="Text"
                        id="text"
                        placeholder="2024T0987"
                    />
                </div>
                {/* botones */}
                <div className='botonesEditarUsuario'>
                    <button type="button" className="btn-acceptEditarUsuarioConfirmar">
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditarUsuario;
